// extracted by mini-css-extract-plugin
export var brand = "_2v-8";
export var compact = "_2v-5";
export var extraSmall = "_2v-6";
export var icon = "_2v-0";
export var large = "_2v-3";
export var light = "_2v-1";
export var medium = "_2v-4";
export var outline = "_2v-a";
export var primaryDark = "_2v-9";
export var primaryLight = "_2v-7";
export var primaryModern = "_2v-b";
export var success = "_2v-2";